/** Google Analytics 4 measurement ID (override via REACT_APP_GA_MEASUREMENT_ID). */
export const GA_MEASUREMENT_ID =
  process.env.REACT_APP_GA_MEASUREMENT_ID?.trim() || "G-64JBKWEGEL";
